"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var react_1 = __importDefault(require("react"));
var icons_1 = __importDefault(require("./../../Atoms/Input/icons"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeDatePickerStyling_1 = __importDefault(require("./makeDatePickerStyling"));
var react_2 = require("@emotion/react");
var DesktopDatePicker_1 = require("@mui/x-date-pickers/DesktopDatePicker");
var DEFAULT_DELAY_TIME = 200; // In order to prevent flickering, we force one operation to take place at any time with a delay.
var DatePicker = function (_a) {
    var id = _a.id, closeDelay = _a.closeDelay, openDelay = _a.openDelay, onChange = _a.onChange, onOpen = _a.onOpen, onClose = _a.onClose, format = _a.format, value = _a.value, errorMessage = _a.errorMessage, placeholder = _a.placeholder, props = __rest(_a, ["id", "closeDelay", "openDelay", "onChange", "onOpen", "onClose", "format", "value", "errorMessage", "placeholder"]);
    var isValid = !errorMessage && !!value;
    var _b = react_1.default.useState(false), isPickerOpen = _b[0], setIsPickerOpen = _b[1];
    var styles = (0, makeDatePickerStyling_1.default)({
        isError: !!errorMessage,
        isValid: isValid,
    });
    var handleChange = function (d) {
        onChange(d ? d : undefined);
    };
    var handleOpen = function () {
        if (isPickerOpen)
            return;
        onOpen();
        setTimeout(function () {
            setIsPickerOpen(true);
        }, openDelay || DEFAULT_DELAY_TIME);
    };
    var handleClose = function () {
        if (isPickerOpen === false)
            return;
        onClose();
        setTimeout(function () {
            setIsPickerOpen(false);
        }, closeDelay || DEFAULT_DELAY_TIME);
    };
    var endAdornment;
    if (isValid || errorMessage) {
        var validationIconType = isValid ? 'valid' : 'invalid';
        var ValidationIconComponent = icons_1.default[validationIconType];
        endAdornment = ((0, jsx_runtime_1.jsx)(InputAdornment_1.default, { position: "end", "data-testid": "endAdornment-".concat(validationIconType), css: styles.inputAdornmentEnd, children: (0, jsx_runtime_1.jsx)(ValidationIconComponent, { fill: "red", viewBox: "2 2 20 20" }) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { css: styles.datePickerContainer, children: [(0, jsx_runtime_1.jsx)(react_2.Global, { styles: styles.globalStyles }), (0, jsx_runtime_1.jsx)(DesktopDatePicker_1.DesktopDatePicker, __assign({ closeOnSelect: true, open: isPickerOpen, onOpen: handleOpen, onClose: handleClose, format: format, slotProps: {
                    inputAdornment: {
                        position: 'start',
                    },
                    textField: {
                        readOnly: true,
                        onClick: isPickerOpen ? handleClose : handleOpen,
                        placeholder: placeholder,
                        InputProps: {
                            endAdornment: endAdornment,
                            id: id,
                            name: 'datePicker',
                        },
                    }, // MUI types doesn't include readOnly, but this is a real prop
                    popper: {
                        placement: 'bottom',
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, -15],
                                },
                            },
                        ],
                    },
                }, value: value, onChange: handleChange }, props))] }));
};
DatePicker.defaultProps = defaultProps_1.default;
exports.default = DatePicker;
//# sourceMappingURL=DatePicker.js.map